import { tokens } from "@core/theme/tokens";

// ADR-007 / SPEC-005: contenido bilingüe llega como {es, en}. El conmutador
// vive DENTRO del formulario y se refiere al contenido que se edita, nunca
// a la interfaz del portal (SPEC-201 §5, siempre en español).
export type ContentLanguage = "es" | "en";

export function LanguageSwitch({
  value,
  onChange,
}: {
  value: ContentLanguage;
  onChange: (lang: ContentLanguage) => void;
}) {
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 4,
        padding: 3,
        borderRadius: tokens.radius.sm,
        border: `1px solid ${tokens.surface.line}`,
      }}
    >
      {(["es", "en"] as const).map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => {
            onChange(lang);
          }}
          style={{
            padding: "5px 12px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            background:
              value === lang ? tokens.surface.surface2 : "transparent",
            color: value === lang ? tokens.text.primary : tokens.text.tertiary,
            font: `600 11.5px ${tokens.font.ui}`,
            textTransform: "uppercase",
          }}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
